module.exports = __webpack_public_path__ + "img/60.5cbcff82.jpg";